// @flow

import { onlyWhenSupport , type UserInputValidationError, type UserInputValidatorArgs, VALID} from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { validatePanamanianDocument } from '@tectonics/prs/panama/validation/panamanian-document';
import { validatePanamanianPhoneNumber } from '@tectonics/prs/panama/validation/panamanian-phone-number';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'panamanianDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_panamanian_document') && validatePanamanianDocument(userInputValue);
      }
      return null;

    case 'panamanianPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_panamanian_phone_number') && validatePanamanianPhoneNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
